import type { DocMigration } from "../docMigration";

function isVirtualRoofBlock(v: unknown): boolean {
  return typeof v === "object" && v !== null && (v as Record<string, unknown>).type === "VIRTUAL_ROOF_BLOCK";
}

/**
 * Migrates VirtualRoofBlock.levelId to VirtualRoofBlock.levelUsage.
 * The levelUsage field is an InstanceScopedNamespacePath<"LEVEL"> which
 * contains entityId and optional componentInstanceChain.
 */
const migration: DocMigration = {
  id: "virtual_roof_block_level_usage",
  description: "Convert VirtualRoofBlock.levelId to VirtualRoofBlock.levelUsage",
  apply(json: any): any {
    const { roofs = {} } = json;

    for (const id in roofs) {
      const roof = json.roofs[id];
      const { blocks } = roof;

      if (!isVirtualRoofBlock(blocks)) {
        continue;
      }

      const { levelId } = blocks;
      blocks.levelUsage = { entityId: levelId };

      delete blocks.levelId;
    }

    return json;
  },
};

export default migration;
